import { ReactNode } from 'react'
import { ApiError } from 'features/common'
import BasicPageHeader from './Partials/BasicPageHeader'
import BasicPageTopButton from './Partials/BasicPageTopButton'
import BasicPageError from './Partials/BasicPageError'
import { Box, styled } from '@mui/material'
import { TypographyProps } from '@carto/meridian-ds/components'

const Root = styled(Box, { shouldForwardProp: (prop) => prop !== 'backgroundColor' })<{
  backgroundColor?: string
}>(({ backgroundColor, theme }) => ({
  backgroundColor: backgroundColor || theme.palette.background.default
}))

interface BasicPageProps {
  title?: ReactNode
  titleId?: string
  titleChildren?: ReactNode
  titleTypographyProps?: TypographyProps
  children?: ReactNode
  primaryAction?: ReactNode
  beforeTitleContent?: ReactNode
  afterTitleContent?: ReactNode
  backUrl?: string
  tight?: boolean
  showScrollToTop?: boolean
  hasError?: ApiError | null // TODO VVG: hasError is not boolean
  headerClassName?: string
  contentClassName?: string
  afterTitleContentClassName?: string
  backgroundColor?: string
}

function BasicPage({
  title,
  titleId,
  titleChildren,
  titleTypographyProps,
  children,
  primaryAction,
  beforeTitleContent,
  afterTitleContent,
  afterTitleContentClassName,
  backUrl,
  tight,
  showScrollToTop,
  hasError,
  headerClassName,
  contentClassName,
  backgroundColor
}: BasicPageProps) {
  return (
    <Root backgroundColor={backgroundColor}>
      <BasicPageHeader
        titleTypographyProps={titleTypographyProps}
        title={title}
        titleId={titleId}
        titleChildren={titleChildren}
        primaryAction={primaryAction}
        beforeTitleContent={beforeTitleContent}
        afterTitleContent={afterTitleContent}
        afterTitleContentClassName={afterTitleContentClassName}
        backUrl={backUrl}
        hasError={hasError}
        headerClassName={headerClassName}
        contentClassName={contentClassName}
      />

      <BasicPageError hasError={hasError} contentClassName={contentClassName} tight={tight} children={children} />

      {showScrollToTop && <BasicPageTopButton showScrollToTop={showScrollToTop} />}
    </Root>
  )
}

export default BasicPage
